<portal-header></portal-header>
<div class="row">
	<div class="col-sm-6 col-sm-offset-3 text-center gray-text-darker mgn-top20">
		<i class="fa fa-frown-o ft-size100" aria-hidden="true"></i>
		<h1 class="ft-size100 mgn-bottom30">We're sorry!</h1>
		<h2 class="mgn-bottom60">{{ message }}</h2>
		<button class="bg-emerald-500 border-radius white-text pd-left10 pd-right10 mgn-top40 ft-size18" [routerLink]="['/my-products']">
			<i class="fa fas fa-chevron-left mgn-right10" aria-hidden="true"></i>
			Return to My Products
		</button>
	</div>
</div>
